<script setup>
import { ref } from 'vue'
import PhysicalStationSelector from './PhysicalStationSelector.vue'
import { choosePhysicalStation, session } from '../session.js'
import { useI18n } from '../i18n.js'
import { apiErrorMessage } from '../api.js'

defineProps({ pts2: Boolean })
const { t } = useI18n()
const saving = ref(false)
const error = ref('')
async function selectStation(stationId) {
  if (saving.value) return
  saving.value = true
  error.value = ''
  try {
    await choosePhysicalStation(stationId)
  } catch (cause) {
    error.value = apiErrorMessage(t, cause, 'platformStationSaveFailed')
  } finally {
    saving.value = false
  }
}
</script>

<template>
  <section class="page-station-context" :aria-label="t('physicalStation')" :aria-busy="saving">
    <PhysicalStationSelector :pts2="pts2" :show-stable-code="!pts2" :context="session.platformContext"
      :disabled="saving" @select="selectStation" />
    <p v-if="error" role="alert">{{ error }}</p>
  </section>
</template>

<style scoped>
.page-station-context { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; margin: 0 0 20px; padding: 12px 16px; border: 1px solid #d4dfe3; border-radius: 8px; background: #fff; }
.page-station-context :deep(.platform-context-selector) { max-width: 100%; }
.page-station-context :deep(select) { min-width: 0; max-width: 100%; }
.page-station-context p { margin: 0; color: #a33038; }
.catalog-page-shell > .page-station-context { width: min(1180px, calc(100% - 64px)); margin: 24px auto 0; }
.pts2-page-shell > .page-station-context { max-width: 1440px; margin: 12px auto 20px; }
@media (max-width: 600px) { .page-station-context :deep(.platform-context-selector) { width: 100%; flex-wrap: wrap; } .page-station-context :deep(select) { flex: 1; } }
</style>
